export const A_QUOTES_SEARCH = "A_QUOTES_SEARCH";
export const A_SET_API_URL = "A_SET_API_URL";
export const A_SET_API_ORIGIN = "A_SET_API_ORIGIN";